export default __webpack_public_path__ + "static/media/profile.6fa80c5c.jpg";